export function encodeStateAndHistory(state, history, maxHistory = 30) {
  // Prepare values
  const version = typeof state.version === 'number' ? state.version : 1;
  const totalPushups = state.totalPushups || 0;
  const currentLevelIndex = state.userProgress?.currentLevelIndex || 0;
  const currentSetIndex = state.userProgress?.currentSetIndex || 0;
  const soundEnabled = state.settings?.soundEnabled ? 1 : 0;
  // Limit history
  const trimmedHistory = (history || []).slice(-maxHistory);
  // Each history entry: 4 bytes date (YYYYMMDD as int), 4 bytes reps
  const entrySize = 8;
  const buffer = new ArrayBuffer(17 + trimmedHistory.length * entrySize);
  const view = new DataView(buffer);
  view.setUint32(0, version);
  view.setUint32(4, totalPushups);
  view.setUint32(8, currentLevelIndex);
  view.setUint32(12, currentSetIndex);
  view.setUint8(16, soundEnabled);
  trimmedHistory.forEach((entry, i) => {
    // Date as YYYYMMDD integer
    const dateInt = parseInt((entry.date || '19700101').replace(/-/g, '')) || 19700101;
    view.setUint32(17 + i * entrySize, dateInt);
    view.setUint32(17 + i * entrySize + 4, entry.reps || 0);
  });
  // Convert to base64
  return btoa(String.fromCharCode(...new Uint8Array(buffer)));
}

export function decodeStateAndHistory(base64) {
  const bin = atob(base64);
  const arr = Uint8Array.from(bin, c => c.charCodeAt(0));
  const view = new DataView(arr.buffer);
  const version = view.getUint32(0);
  const totalPushups = view.getUint32(4);
  const currentLevelIndex = view.getUint32(8);
  const currentSetIndex = view.getUint32(12);
  const soundEnabled = !!view.getUint8(16);
  const history = [];
  for (let i = 17; i + 7 < arr.length; i += 8) {
    const dateInt = view.getUint32(i);
    const reps = view.getUint32(i + 4);
    // Convert YYYYMMDD int to string
    const dateStr = dateInt.toString();
    const date = dateStr.slice(0, 4) + '-' + dateStr.slice(4, 6) + '-' + dateStr.slice(6, 8);
    history.push({ date, reps });
  }
  return {
    state: {
      version,
      totalPushups,
      userProgress: { currentLevelIndex, currentSetIndex },
      settings: { soundEnabled }
    },
    history
  };
}
